import type { GraphState } from "./types"

export const initialState: GraphState = {
  rootCustomerId: undefined,
  selectedVertices: [],
  hoveredNode: null,
  sidebarLockedNode: null,
  sidebarVisible: false,
  disableInteractions: false,
  canvasWidth: 0,
  canvasHeight: 0,
  panPosition: { x: 0, y: 0 },
  zoomLevel: 1
}
